<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tW362e/tc-custom/9780830868773.jpg?1696025386974" alt="This image is the cover for the book Exploring the Old Testament, Exploring the Bible Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Exploring the Old Testament, Exploring the Bible Series
      </h1>
      <p class="bookDescription body article font2">
        <p>The historical books, from Joshua to Ezra and Nehemiah, form the narrative backbone of the Old Testament. Without them the Pentateuch would stop cold and the Prophets would hang in suspension. Even the Psalms and Wisdom literature would lose some of their luster for lack of a setting. Without these historical books the New Testament would be resolving an incomplete narrative, answering a question only half and hesitantly posed. For all these reasons and more, it is a tragic fact that many of us today cannot give a brief and coherent account of this story. We fear that books with names like Judges, Kings and Chronicles would bore us. But nothing could be further from the truth. For the story they tell is full of action and intrigue, tragedy and suspense, vivid characters and memorable events. They are the stuff of great art and literature, and they have inspired men and women to lives and deeds of uncommon faith and courage. Exploring these books is essential for a true education, whether religious or otherwise. In this guidebook, Philip E. Satterthwaite and J. Gordon McConville introduce us to the content and the context of these historical books. We view them within the setting of ancient history and history writing, and come to appreciate their literary artistry, their role within the Scriptures of Israel, and their lasting value as theological and ethical resources. Designed especially for students,<em>Exploring the Old Testament, Volume 2: A Guide to the Historical Books</em> overflows with interesting and helpful features that encourage avid exploration and the joy of learning.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philip E. Satterthwaite, J. Gordon McConville
      </h2>
      
      <p class="authorDescription body article"><p>Satterthwaite is lecturer in Old Testament, Hebrew and hermeneutics at Biblical Graduate School of Theology in Singapore.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?063e3c8c